const initialState = {
  status: {},
  data: { msgHotkey: 'CtrlEnter' },
}

const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const userPreferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_USER_PREFERENCES':
      const { [action.payload]: key, ...rest } = state.status
      return !key
        ? initialState
        : {
            ...state,
            status: {
              ...rest,
            },
          }
    case 'USER_PREFERENCES_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'SET_USER_PREFERENCES':
      return {
        ...state,
        data: action.payload,
        status: {
          set_preferences: {
            ...initialStatus,
            success: true,
          },
        },
      }

    default:
      return state
  }
}

export default userPreferencesReducer
